module.exports = (() => {
    let _elements = {};

    let _searchFactory = require('../../modules/search/search');
    let _search;

    let _toggleMenu = (event, focusInput) => {
        event.preventDefault();

        focusInput = focusInput || false;

        let active = $(event.currentTarget).attr('data-active');

        if (!active || active === 'false') {
            _elements.$menuIcon.attr('data-active', true);
            _elements.$menuSearch.attr('data-active', true);
            _elements.$menuNavigation.attr('data-active', true);
            _elements.$body.attr('data-menu-open', true);

            if (focusInput) {
                setTimeout(() => {
                    _search.focusSearchField();
                }, 500);
            }
        } else {
            _elements.$menuIcon.attr('data-active', false);
            _elements.$menuSearch.attr('data-active', false);
            _elements.$menuNavigation.attr('data-active', false);
            _elements.$body.attr('data-menu-open', false);
        }
    };

    let _toggleDgbMenu = (event) => {
        event.preventDefault();
        const isExpanded = _elements.$dgbMenu.attr('aria-expanded')
        const val = isExpanded === 'false' ? 'true' : 'false'
        _elements.$dgbMenu.attr('aria-expanded', val)
        _elements.$dgbToggle.attr('aria-expanded', val)
    }

    let _toggleSearch = (event) => {
        _toggleMenu(event, true)
    };

    let _events = () => {
        _elements.$menuIcon.on('click', _toggleMenu);
        _elements.$menuSearch.on('click', _toggleSearch);
        _elements.$dgbToggle.on('click', _toggleDgbMenu);
    };

    let _cacheDom = (element) => {
        _elements.$menuIcon = element.find('#menu-toggler');
        _elements.$menuSearchContainer = element.find('.search--menu');
        _elements.$menuSearch = element.find('.header__search-icon');
        _elements.$menuNavigation = element.find('.header__navigation');
        _elements.$menuItemStores = element.find('.menu-item-stores');
        _elements.$menuItemStoresDropdown = element.find('.menu-item-stores-dropdown');
        _elements.$body = $('body');
        _elements.$dgbToggle = $('#dgb-dropdown');
        _elements.$dgbMenu = $('#dgb-menu');
    };

    return {
        init: () => {
            let element = $('.header');

            _cacheDom(element);
            _events();

            _search = _searchFactory.create();
            _search.init(_elements.$menuSearchContainer);
        }
    }
})();
